import {
  AUTH_SET_LINK_AUTH_OBJECT
} from "../../constants/auth";

export const AUTH_SET_LINK_AUTH_OBJECT_ACTION = (obj) => ({
  type: AUTH_SET_LINK_AUTH_OBJECT,
  payload: obj
});

